/**
 * 
  ____                                        _     _   _       _                 _ 
 |  _ \  ___   ___ _   _ _ __ ___   ___ _ __ | |_  | | | |_ __ | | ___   __ _  __| |
 | | | |/ _ \ / __| | | | '_ ` _ \ / _ \ '_ \| __| | | | | '_ \| |/ _ \ / _` |/ _` |
 | |_| | (_) | (__| |_| | | | | | |  __/ | | | |_  | |_| | |_) | | (_) | (_| | (_| |
 |____/ \___/ \___|\__,_|_| |_| |_|\___|_| |_|\__|  \___/| .__/|_|\___/ \__,_|\__,_|
                                                         |_|                        

 */
import { Component, Input } from '@angular/core';
import { IMember } from 'src/app/features/member/member-details/state/member-details.model';

@Component({
  selector: 'app-document-upload', // Define the selector for your component
  templateUrl: './document-upload.component.html', // Link to the template file
  styleUrls: ['./document-upload.component.scss'] // Link to the stylesheet
})
export class DocumentUploadComponent {
  @Input() uploadStyle: 'text' | 'icon' = 'text'; //Input to choose to have text display in the button or icon only.
  @Input() uploadMode: 'single' | 'multiple' = 'single'; // Input to choose between single or multiple file upload modes
  @Input() uploadKey?: IMember; // Intended for passing IMember to  create a unique document ID for file upload
  @Input() maxFileSizeMB: number = 10; // Default is 10 MB, Change as needed via @Input value.
  @Input() uploadTitle?: string; // Input for title of the modal


  showModal = false; // Boolean to control the visibility of the modal
  selectedFile: File | FileList | null = null; // Store the selected file(s)
  fileError: string | null = null; // Store any error message related to file handling
  uploadUniqueID: string[] = []; // File upload unique ID associated with the member

  constructor() {}

  // Event handler for file selection
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = this.uploadMode === 'single' ? input.files[0] : input.files; // Choose how to store the file based on the upload mode
      this.fileError = null; // Reset any existing error messages
      this.generateFileUniqueID(); // update ID when file selected

      if(!this.validateFile(input.files)) {
        this.selectedFile = null;
      }
    }
  }

  // This will create the unique ID for the file tide with the memberID
  generateFileUniqueID(): void {
    if(this.uploadMode === 'single' && this.selectedFile instanceof File) {
      this.uploadUniqueID = [`POL${this.uploadKey.memberId}_${this.selectedFile.name}`];
    } else if(this.uploadMode === 'multiple' && this.selectedFile instanceof FileList) {
      this.uploadUniqueID = Array.from(this.selectedFile).map(file => `POL${this.uploadKey?.memberId}_${file.name}`);
    }
  }

  // Validate the files for size, type, or any other criteria
  validateFile(files: FileList): boolean {
      let isValid = true; // Assume all files are valid initially
      Array.from(files).forEach(file => {
          // Check if file size is greater than maxFileSizeMB
          if (file.size > this.maxFileSizeMB * 10485760) { 
              this.fileError = `File size is too large. Maximum file size is ${this.maxFileSizeMB} MB.`;
              isValid = false; // Set to false if any file is too large
          }

          // Define allowed file extensions
          const allowedExtensions = /(\.bmp|\.doc|\.docx|\.csv|\.gif|\.jpeg|\.jpg|\.pdf|\.png|\.rtf|\.tif|\.tiff|\.txt|\.xl|\.xla|\.xlc|\.xlm|\.xls|\.xlw)$/i;
          if (!allowedExtensions.test(file.name)) {
              this.fileError = 'File format is not supported. Accepted file formats are .bmp, .doc, .docx, .csv, .gif, .jpeg, .jpg, .pdf, .png, .rtf, .tif, .tiff, .txt, .xl, .xla, .xlc, .xlm, .xls, .xlw';
              isValid = false; // Set to false if the file format is not allowed
          }
      });
      return isValid; // Return the overall validity of the file(s)
  }

  // Function to simulate file upload process
  uploadFile(): void {
    console.log("Files ready to be uploaded:", this.uploadUniqueID);
  }

  // Function to close the modal dialog
  close(): void {
    this.showModal = false;
  }
}
